/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSimilarItemsFooter_item = {
    readonly isArt: boolean | null;
    readonly isSold: boolean | null;
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
    readonly " $refType": "PdpRespSimilarItemsFooter_item";
};
export type PdpRespSimilarItemsFooter_item$data = PdpRespSimilarItemsFooter_item;
export type PdpRespSimilarItemsFooter_item$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsFooter_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a900c16a28e2487bb5dade7012db9199';
export default node;
